import { useMemo } from "react";
import { FaBuilding } from "react-icons/fa";
import { LuLayers, LuPackage, LuHandshake } from "react-icons/lu";
import { MdBusiness } from "react-icons/md";
import { useAuth } from "../authentication/AuthProvider";
import routing from "../routing";
import CommonSidebar from "./CommonSidebar";

const SideBar = () => {
  const { isEngagementEnabled, isOrganizationEnabled, isProductEnabled, isProjectEnabled, isBuildingEnabled } = useAuth();
  const tabs = useMemo(
    () => [
      {
        label: "Products",
        value: "products",
        icon: LuPackage,
        subHeader: "Features",
        rootPath: routing.sector.products.root,
        path: routing.sector.products.dashboard,
        visibility: isProductEnabled,
      },
      {
        label: "Projects",
        value: "projects",
        icon: LuLayers,
        subHeader: "Features",
        rootPath: routing.sector.projects.root,
        path: routing.sector.projects.dashboard,
        visibility: isProjectEnabled,
      },
      {
        label: "Buildings",
        value: "buildings",
        icon: FaBuilding,
        subHeader: "Features",
        rootPath: routing.sector.buildings.root,
        path: routing.sector.buildings.dashboard,
        visibility: isBuildingEnabled,
      },
      {
        label: "Organization",
        value: "organization",
        icon: MdBusiness,
        subHeader: "Features",
        rootPath: routing.organization.root,
        path: routing.organization.supply_chain.dashboard,
        visibility: isOrganizationEnabled,
      },
      {
        label: "Engagement",
        value: "engagement",
        icon: LuHandshake,
        subHeader: "Features",
        rootPath: routing.engagement.root,
        path: routing.engagement.supplier_directory.dashboard,
        visibility: isEngagementEnabled,
      },
    ],
    [isEngagementEnabled, isOrganizationEnabled, isProductEnabled, isProjectEnabled, isBuildingEnabled]
  );

  return <CommonSidebar tabs={tabs} />;
};

export default SideBar;
